// extracted by mini-css-extract-plugin
export default {"discountCode":"checkout-coupon-form_discountCode__E+kzI"};